import StatsBlocks from './StatsBlocks';

export default StatsBlocks;
